import React from "react";

const CircleFifthsImg = props => (
  <svg
    id="circleFifths"
    className="circleFifths"
    width={395.51}
    height={395.51}
    {...props}
  >
    <path fill="none" d="M-1-1h582v402H-1z" />
    <g className="note note_D">
      <path
        stroke="#000"
        fillOpacity={0}
        fill="#ffff00"
        strokeWidth={2}
        d="M338.82 89.439a164.33 164.33 0 0 1 16.438 39.559l-52.903 14.267a106.764 106.764 0 0 0-28.397-49.186l38.797-38.682A163.523 163.523 0 0 1 338.82 89.44z"
      />
      <text
        stroke="#000"
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={148.669}
        x={272.905}
        fillOpacity="null"
        strokeWidth={0}
      >
        {"D"}
      </text>
    </g>
    <g className="note note_Aflat">
      <path
        stroke="#000"
        fillOpacity={0}
        strokeWidth={2}
        fill="#0000ff"
        d="M53.677 253.4a164.285 164.285 0 0 1-16.438-39.57l52.903-14.268a106.764 106.764 0 0 0 28.397 49.197l-38.797 38.67a163.73 163.73 0 0 1-26.065-34.03z"
      />
      <text
        stroke="#000"
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={267.669}
        x={62.905}
        strokeWidth={0}
      >
        {"A\u266D"}
      </text>
    </g>
    <g className="note note_F">
      <path
        stroke="#000"
        fillOpacity={0}
        strokeWidth={2}
        d="M113.69 28.27a164.285 164.285 0 0 1 39.56-16.437l14.267 52.903a106.649 106.649 0 0 0-49.174 28.385l-38.67-38.797A163.915 163.915 0 0 1 113.69 28.27z"
        fill="#129614"
      />
      <text
        stroke="#000"
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={101.669}
        x={113.905}
        fillOpacity="null"
        strokeWidth={0}
      >
        {"F"}
      </text>
    </g>
    <g className="note note_B">
      <path
        stroke="#000"
        fillOpacity={0}
        strokeWidth={2}
        fill="#ee82ee"
        d="M278.818 313.425a163.361 163.361 0 0 1-39.57 16.426L224.98 276.96a106.81 106.81 0 0 0 49.174-28.397l38.682 38.809a164.17 164.17 0 0 1-34.018 26.053z"
      />
      <text
        stroke="#000"
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={307.669}
        x={229.905}
        strokeWidth={0}
      >
        {"B"}
      </text>
    </g>
    <g className="note note_G">
      <path
        stroke="#000"
        strokeWidth={2}
        fill="#00ffff"
        fillOpacity={0}
        d="M277.652 28.27a163.523 163.523 0 0 1 34.018 26.054L273 93.132a106.649 106.649 0 0 0-49.186-28.396l14.267-52.903a164.285 164.285 0 0 1 39.57 16.438z"
      />
      <text
        stroke="#000"
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={104.669}
        x={227.905}
        strokeWidth={0}
      >
        {"G"}
      </text>
    </g>
    <g className="note noteDflat">
      <path
        stroke="#000"
        fillOpacity={0}
        fill="#ff8c00"
        strokeWidth={2}
        d="M113.702 313.425a163.915 163.915 0 0 1-34.018-26.042l38.682-38.808a106.81 106.81 0 0 0 49.174 28.396l-14.29 52.88a164.285 164.285 0 0 1-39.548-16.426z"
      />
      <text
        stroke="#000"
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={310.669}
        x={105.905}
        strokeWidth={0}
      >
        {"D\u266D"}
      </text>
    </g>
    <g className="note note_Bflat">
      <path
        stroke="#000"
        fillOpacity={0}
        strokeWidth={2}
        fill="#8a2be2"
        d="M53.677 88.284A163.915 163.915 0 0 1 79.73 54.266l38.809 38.682a106.533 106.533 0 0 0-28.397 49.174L37.24 127.843a164.285 164.285 0 0 1 16.438-39.57v.011z"
      />
      <text
        stroke="#000"
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={145.669}
        x={60.905}
        fillOpacity="null"
        strokeWidth={0}
      >
        {"B\u266D"}
      </text>
    </g>
    <g className="note note_E">
      <path
        stroke="#000"
        strokeWidth={2}
        fillOpacity={0}
        fill="#FFFFFF"
        d="M338.832 253.411a163.915 163.915 0 0 1-26.054 34.019l-38.808-38.67a106.649 106.649 0 0 0 28.396-49.187l52.892 14.28a164.4 164.4 0 0 1-16.438 39.558h.012z"
      />
      <text
        stroke="#000"
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={266.669}
        x={273.905}
        strokeWidth={0}
      >
        {"E"}
      </text>
    </g>
    <g className="note note_A">
      <path
        stroke="#000"
        fillOpacity={0}
        strokeWidth={2}
        fill="#87cefa"
        d="M360.798 170.276a164.25 164.25 0 0 1-5.54 42.491l-52.95-14.094a106.764 106.764 0 0 0 0-56.782l52.95-14.048a164.227 164.227 0 0 1 5.552 42.48l-.012-.047z"
      />
      <text
        stroke="#000"
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={204.669}
        x={287.905}
        fillOpacity="null"
        strokeWidth={0}
      >
        {"A"}
      </text>
    </g>
    <g className="note note_Eflat">
      <path
        stroke="#000"
        fillOpacity={0}
        strokeWidth={2}
        fill="#c0c0c0"
        d="M31.71 170.265a164.25 164.25 0 0 1 5.552-42.491l52.95 14.094a106.81 106.81 0 0 0 0 56.793l-52.95 14.083a164.227 164.227 0 0 1-5.552-42.48z"
      />
      <text
        stroke="#000"
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={206.669}
        x={47.905}
        fillOpacity="null"
        strokeWidth={0}
      >
        {"E\u266D"}
      </text>
    </g>
    <g className="note note_C">
      <path
        stroke="#000"
        fillOpacity={0}
        fill="#ff0000"
        strokeWidth={2}
        d="M196.826 6.304a163.603 163.603 0 0 1 42.479 5.552l-14.083 52.95a106.81 106.81 0 0 0-56.793 0l-14.025-52.95a163.661 163.661 0 0 1 42.422-5.552z"
      />
      <text
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={88.669}
        x={170.613}
        fillOpacity="null"
        strokeOpacity="null"
        strokeWidth={0}
      >
        {"C"}
      </text>
    </g>
    <g className="note note_Fsharp">
      <path
        stroke="#000"
        strokeWidth={2}
        fillOpacity={0}
        fill="#00ff7f"
        d="M196.837 335.392a164.308 164.308 0 0 1-42.433-5.54l14.094-52.95a106.81 106.81 0 0 0 56.793 0l14.026 52.95a164.158 164.158 0 0 1-42.48 5.54z"
      />
      <text
        stroke="#000"
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={325.669}
        x={165.905}
        strokeWidth={0}
      >
        {"F#"}
      </text>
    </g>
    <g className="note note_Gflat">
      <path
        stroke="#000"
        strokeWidth={2}
        fillOpacity={0}
        fill="#00ff7f"
        d="M196.249 390.8a242.485 170.793 0 0 1-62.623-5.76l20.8-55.039a157.63 111.026 0 0 0 83.816 0l20.698 55.04a242.264 170.637 0 0 1-62.691 5.759z"
      />
      <text
        stroke="#000"
        transform="translate(-9.107 -59.016) scale(1.15433)"
        fontWeight="bold"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize={24}
        y={374.669}
        x={165.905}
        strokeWidth={0}
      >
        {"G\u266D"}
      </text>
    </g>
    <text
      stroke="#000"
      transform="translate(-9.107 -59.016) scale(1.15433)"
      fontFamily="Helvetica, Arial, sans-serif"
      fontSize={24}
      y={203.669}
      x={153.905}
      strokeWidth={0}
    >
      {"Root"}
    </text>
  </svg>
);

export default CircleFifthsImg;
